import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  module: string;

  constructor(private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        if (params.source && params.source.length > 0) {
          const uri = decodeURI(params.source);
          this.router.navigate([], {relativeTo: this.route});
          const matches = uri.match(/^\/([a-zA-Z\d]{6,8})\//);
          if (matches) {
            this.module = matches[1];
          }
        }
      });
  }
}
